import Helper from './Helper';

class FootnoteSpan {
  constructor(config = {}) {
    const {
      footnoteSelector,
    } = config;

    this.footnoteSelector = document.querySelectorAll(footnoteSelector);
    this.graphicsSelectorArray = Array.prototype.slice.call(this.footnoteSelector);

    if (this.graphicsSelectorArray.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.graphicsSelectorArray.forEach((item)=>{
      let allItems = item.querySelectorAll('span');
      allItems.forEach((it, i) => {
        if (i === 0){
          let wrapper = document.createElement("span");
          wrapper.classList.add('ns-style-footnote-wrapper');
          let next = Helper.nextAll(it);
          next.forEach((el)=>{
            wrapper.appendChild(el);
          });
          item.appendChild(wrapper);
        }
      });
    });
  }
}

export default FootnoteSpan;
